import SmoothAnchorLink from 'react-anchor-link-smooth-scroll'
import { Col, Container, Row } from 'styled-bootstrap-grid'
import styled from 'styled-components'

import { hideBlockAt, marginBreakpoints } from '../../../../utils/commonAttrs'
import { spacing } from '../../../../utils/ui/spacing'
import { fromBreakpoint } from '../../../../utils/style/breakpoint'

type AnchorNavProps = {
  marginBottom?: any
  hiddenAt?: any
}

export const AnchorNav = styled.div<AnchorNavProps>`
  background-color: ${({ theme }) =>
    theme.id === 'mf-2023-light'
      ? theme.tokens.space.primary.regular
      : theme.tokens.space.tertiary.regular};
  ${({ marginBottom }) => marginBreakpoints({ marginBottom }, 0)};
  ${({ hiddenAt }) => hideBlockAt({ hiddenAt })};
  padding: 0 ${spacing('md')};
`

export const TextLink = styled(Col)`
  border-right: 1px solid ${({ theme }) => theme.tokens.interface.neutral.light};
  font-family: ${({ theme }) => theme.typography.font.family.title};
  font-weight: 400;
  flex: 1;
  text-align: center;
  min-height: 56px;
  flex-basis: calc(33% - ${spacing('md')});

  &:last-child {
    border-right: none;
  }

  ${fromBreakpoint('lg')} {
    flex-basis: 0;
  }
`

export const TheContainer = styled(Container)`
  padding: ${spacing('xl')} 0;
`

export const StyledRow = styled(Row)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: ${spacing('md')};

  ${fromBreakpoint('lg')} {
    gap: 0;
  }
`

export const Anchor = styled(SmoothAnchorLink)`
  display: block;
  text-decoration: none;
  padding: 15px;
  color: ${({ theme }) => theme.tokens.accent.base.secondary.regular};
  border-bottom: 5px solid transparent;
  transition: border-color 75ms ease-in-out;

  &:focus,
  &:hover {
    color: ${({ theme }) => theme.tokens.accent.base.secondary.strong};
    border-color: ${({ theme }) =>
      theme.id === 'mf-2023-light'
        ? theme.tokens.accent.token.primary.strong
        : theme.tokens.accent.base.secondary.strong};
  }
`
